import React from 'react'
import useIsMobile from '@/hooks/useIsMobile'
import useIsTablet from '@/hooks/useIsTablet'
import { getSEOFriendlyURL } from '@/lib/utilities/Utils'
import CustomImage from '@/components/common/custom-image'
import { useRouter } from 'next/router'

interface StoreCategory {
  storeTypeId: number
  storeTypeName: string
  image: string
}
interface ShopCategoryProps {
  storeCategory: StoreCategory[]
  selectedCategory: string
  isLocalityPage?: boolean
  city?: string
  locality?: string
}

const ShopCategory = (props: ShopCategoryProps): JSX.Element => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const router = useRouter()
  const { storeCategory, selectedCategory, isLocalityPage = false, city, locality } = props

  const handleCategoryClick = (storeTypeName: string): void => {
    const seoStoreTypeName = getSEOFriendlyURL(storeTypeName)
    if (isLocalityPage) {
      router.push(`/${getSEOFriendlyURL((city))}/${getSEOFriendlyURL((locality))}/${seoStoreTypeName}`).catch(() => {})
      return
    }
    router.push(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          storeCategory: getSEOFriendlyURL(storeTypeName)
        }
      },
      undefined,
      { shallow: true }
    ).catch(() => {})
  }

  return (
    <>
      {
        isMobile || isTablet
          ? (
              <div className='flex overflow-x-scroll scrollbar-none'>
                {
                  storeCategory?.map((category) => (
                    <div
                      key={category?.storeTypeId}
                      className={`${(selectedCategory === getSEOFriendlyURL(category?.storeTypeName) && !isMobile) ? 'bg-[#fff2fb] bg-gradient-to-l from-[#B8238E50] to-[#FFFFFF]' : ''}
                        py-1.5 px-2.5 mr-2 bg-[#FFFFFF] font-bold border-none flex flex-col text-center content-center decoration-black`}
                    >
                      <button
                        type='button'
                        role="category-button"
                        onClick={() => {
                          handleCategoryClick(category.storeTypeName)
                        }}
                      >
                        <CustomImage
                          imageType='CATEGORY'
                          imageUrl={category?.image}
                          imageAlt={category?.storeTypeName}
                          imageTitle={category?.storeTypeName}
                          imageStyle='h-[82px] w-[82px] object-contain rounded-[20px] self-center'
                        />
                        <div
                          className={`${selectedCategory === getSEOFriendlyURL(category?.storeTypeName) ? 'text-[#b8238e] border-b-2 border-[#b8238e]' : ''}
                            w-[82px] h-[50px] py-2 text-wrap text-sm line-clamp-2 text-ellipsis`}
                        >
                          {category?.storeTypeName}
                        </div>
                      </button>
                    </div>
                  ))
                }
              </div>
            )
          : (
              <div className='inline-flex flex-col max-h-[830px] overflow-y-scroll no-scrollbar border-r my-2 mx-0'>
                {
                  storeCategory?.map((category) => (
                    <div
                      key={category?.storeTypeId}
                      className={`${selectedCategory === getSEOFriendlyURL(category?.storeTypeName) ? 'bg-[#fff2fb] bg-gradient-to-l from-[#B8238E50] to-[#FFFFFF]' : ''}
                      py-1.5 px-2 mx-[0%] bg-[#FFFFFF] font-bold flex flex-col content-center decoration-black`}
                    >
                      <button
                        type='button'
                        role="category-button"
                        onClick={() => {
                          handleCategoryClick(category.storeTypeName)
                        }}
                      >
                        <div className='flex items-center flex-nowrap'>
                          <div className=''>
                            <CustomImage
                              imageType='CATEGORY'
                              imageUrl={category?.image}
                              imageAlt={category?.storeTypeName}
                              imageTitle={category?.storeTypeName}
                              imageStyle='h-[82px] w-[82px] object-contain rounded-[20px] self-center'
                            />
                          </div>
                          <div
                            className={`${selectedCategory === getSEOFriendlyURL(category?.storeTypeName) ? 'text-[#b8238e]' : ''} text-wrap pl-2 text-left shrink-0 px-2`}
                          >
                            {category?.storeTypeName}
                          </div>
                        </div>
                      </button>
                    </div>
                  ))
                }
              </div>
            )
      }
    </>
  )
}

export default ShopCategory
